<template>
  <div class="row">
        <br/>
        <br/>
          <div class="col-lg-12">
            <div class="card alert">
              <div class="card-header"></div>
              <div v-if="authyReady">
                <div class="col-sm-6">
                  <h4>Inserte su código</h4>
                  <br />
                  <br />
                  <input type="text" placeholder="código" id="codigo" class="form-control">
                  <br/>
                  <br/>
                    <button class="btn btn-primary btn-flat" @click="checarCodigo">
                          Checar
                        </button>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>

              <div v-else>
                <div class="col-sm-6">
                  <h4>Agrega código a 2FA App</h4>
                  <br />
                 
                  <br/>
                  <br/>
                    <button class="btn btn-primary btn-flat" @click="goToAuthy">
                          Continuar
                        </button>
                  <br />
                  <br />
                </div>
                <div class="col-sm-6">
                   <img src="" id="qrImage">
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>

            </div>
          </div>
          <!-- /# column -->
        </div>
</template>
<script>
import firebase from 'firebase'
import router from "@/router.js"

export default {
    methods:{
      registerUser: function() {

        var user = firebase.auth().currentUser

        if(user){
            if(user.photoURL != null){
              this.authyReady = true
              this.$speakeasy.totp({
                secret: user.photoURL,
                encoding: 'base32'
              });
            }
            else{
              var secret = this.$speakeasy.generateSecret({length: 20});

              user.updateProfile({
                photoURL: secret.base32
              }).then(() => {
                console.log(user.photoURL)
                this.$QRCode.toDataURL(secret.otpauth_url, function(err, image_data) {
                  document.getElementById("qrImage").src = image_data
                })
              })
            }
        }
      },
      goToAuthy: function(){
        this.authyReady = true
      },
      checarCodigo: function(){
        var authyCode = document.getElementById("codigo").value
        console.log(authyCode)
        var user = firebase.auth().currentUser

        if(user){
          console.log(user.photoURL)
          var verified = this.$speakeasy.totp.verify({
            secret: user.photoURL,
            encoding: ['base32'],
            token: authyCode,
            window: 2
          })

          console.log(verified)
        }

        router.push("/register/user").catch(err => {
              console.log(err);
            });
      }
    },
    mounted() {
      this.registerUser()
    },
    data() {
    return {
      authyReady: false
    };
  }
}
</script>